<template>
    <div class="theme-divider">
        <span>
            <slot name="label" />
        </span>
        <hr>
    </div>
</template>

<script>
export default {
    name: "ThemeDivider"
}
</script>

<style lang="scss">
.theme-divider {
    margin-top: 50px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    span {
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
        color: white;
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        margin-left: 10px;
    }

    hr {
        flex-basis: 0;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
        margin-bottom: 0;
        margin-top: 0;
    }
}
</style>
